var cancelCallback = null;
var ChangePasswordForm = Backbone.Epoxy.View.extend({
  template: 'modals.changePasswordForm',

  events: {
    'click #changePasswordButton': 'changePassword',
    'submit #changePassword': function() { return false; },
    'click .close': 'onCancel',
    'keydown .close': 'onCancel'
  },
    
  initialize: function() {
    this.hasRendered = false;
  },

  cleanup: function() {
    this.model.set("oldPassword", null);
    this.model.set("newPassword", null);
    this.model.set("newPasswordConfirm", null);
    this.model.set("validationSuspended", true);
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  /**
   * Boilerplate after render for modals.
   */
  afterRender: function() {
    this.$el.modal({
      show: false
    });

    this.$el.on('hide.bs.modal', function(e) {
      if ('parentIFrame' in window) {
        parentIFrame.sendMessage({event: 'closeModal'});
        $('body').css('background', 'transparent');
      } else {
        cancelCallback({success: false, userError: "Please update you password"});
        console.log('No parent, oh noes')
      }
    });
    this.applyBindings();
  },

  /**
  * Show this form.
  */
  show: function() {
    Backbone.Validation.unbind(this.model);
    this.cleanup();
    Backbone.Validation.bind(this.model);
    var successPayload = this.model.get("successPayload");
    if(successPayload &&  successPayload.errorCallback && typeof successPayload.errorCallback === 'function') {
      cancelCallback= successPayload.errorCallback;
    }
    this.$el.modal('show');
    if ('parentIFrame' in window) {
      parentIFrame.sendMessage({event: 'openModal'});
      $('body').css('background', '#fbfbfb');
    } else {
      console.log('No parent, oh noes')
    }
  },

  /**
   * AJAX call to change the password 
   */
  changePassword: function() {
    this.model.set("validationSuspended", false);
    if(this.model.isValid(true)) {
      $.ajax({
        url: bookedby.routes.AUTHENTICATION.CHANGE_PASSWORD,
        method: "POST",
        data: JSON.stringify(this.model.toJSON()),
        contentType: "application/json",
        cache: false,
        success: function(data) {
          if (!data.success) {
            if (data.userError) {
              var options = {
                message: data.error,
                cancelLabel: '',
                confirmLabel: 'Ok',
                showCancelLabel: false,

              };
              bookedby.app.confirmForm.show(function () {}, function () {}, options);
            } else {
              bookedby.app.logAPIError(data.error);
            }
          } else {
            var successPayload = this.model.get("successPayload")
            bookedby.app.currentClient.logIn({client: data});
            if(successPayload &&  successPayload.successCallback && typeof successPayload.successCallback === 'function') {
              successPayload.successCallback(data);
            } else {
              bookedby.app.navigateAfterAuthenticated('profile', {});
            }
            this.$el.modal('hide');
          }  
        }.bind(this),
        error: _.bind(function(jqXHR, textStatus, textError) {
          bookedby.app.logAPIError(textError);
        }, this)
      });
    }
  },
  onCancel: function(e) {
    if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
      this.cleanup();
      this.$el.modal('hide');
    }
  },
  
});

module.exports = ChangePasswordForm;